//
//
//
//
//
//
//
//
//
//

import VueApexCharts from 'vue-apexcharts';
import merge from 'lodash.merge';
import { formatNumber } from 'src/util/filter';

export default {
	name: 'BaseChart',
	components: {
		apexchart: VueApexCharts,
	},

	props: {
		series: {
			'type': Array,
			'required': true,
			'default': () => [],
		},
		type: {
			'type': String,
			'default': 'line',
		},
		options: {
			type: Object,
		},
		width: {
			type: [String, Number],
		},
		height: {
			type: [String, Number],
		},
	},

	data() {
		return {
			defaultOptions: {
				colors: ['#1635FB', '#13BDA6', '#FF8051', '#6200EA', '#2962ff', '#AA00FF'],
				legend: {
					position: 'top',
					horizontalAlign: 'right',
				},
				dataLabels: {
					enabled: false,
				},
				xaxis: {
					type: 'datetime',
					tooltip: {
						enabled: false,
					},
				},
				yaxis: {
					tickAmount: 1,
					labels: {
						formatter(value) {
							return formatNumber(value, { fractionDigits: 0 });
						},
					},
				},
				chart: {
					toolbar: {
						show: false,
					},
					locales: [{
						name: 'de',
						options: {
							months: [
								'Januar',
								'Februar',
								'März',
								'April',
								'Mai',
								'Juni',
								'Juli',
								'August',
								'September',
								'Oktober',
								'November',
								'Dezember',
							],
							shortMonths: [
								'Jan',
								'Feb',
								'Mär',
								'Apr',
								'Mai',
								'Jun',
								'Jul',
								'Aug',
								'Sep',
								'Okt',
								'Nov',
								'Dez',
							],
							days: [
								'Sonntag',
								'Montag',
								'Dienstag',
								'Mittwoch',
								'Donnerstag',
								'Freitag',
								'Samstag',
							],
							shortDays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
						},
					}],
					defaultLocale: 'de',
				},
				noData: {
					text: 'Keine Daten verfügbar',
					align: 'center',
					verticalAlign: 'middle',
					offsetX: 0,
					offsetY: 0,
					style: {
						color: undefined,
						fontSize: '14px',
						fontFamily: undefined,
					},
				},
				stroke: {
					width: 2,
				},
			},
			responsive: [
				{
					breakpoint: 1000,
					options: {
						plotOptions: {
							bar: {
								horizontal: false,
							},
						},
						legend: {
							position: 'bottom',
						},
					},
				},
			],
		};
	},

	computed: {
		mergedOptions() {
			const options = {};

			merge(options, this.defaultOptions);
			merge(options, this.options);

			if (this.type === 'pie') {
				delete options.xaxis.type;
			}

			return options;
		},
	},
};
